import { render } from "./SnackbarComponent.vue?vue&type=template&id=7f24afe8"
import script from "./SnackbarComponent.vue?vue&type=script&lang=js"
export * from "./SnackbarComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__